import React from "react";

const JQuery_CSS = () => {
  return (
    <div>
      <h1>JQuery_CSS</h1>
      <p>Placeholder component for: "JQuery_CSS"</p>
    </div>
  );
};

export default JQuery_CSS;
